import LedZeroOne from "../../../../docs/_images/led_01.png";
import * as React from 'react';
export default {
  LedZeroOne,
  React
};